<template>
  <v-layout fill-height column>
    <v-container flex-fill fluid>
      <SolutionIntro :title="title" :time="time" :smallTitle="smallTitle" :description="description" :photo="photo"
                     :movie="movie" :sound="sound"/>
    </v-container>
    <FooterBtns :ok="'시작하기'" @submit="$emit('next')" class="bg--white"/>
  </v-layout>
</template>

<script>
import utils from '@/utils/utils'
import SolutionIntro from "@/components/solution/SolutionIntro";
import FooterBtns from "@/components/btns/FooterBtns"

export default {
  components: {
    SolutionIntro,
    FooterBtns
  },
  props: {
    title: String,
    time: Number,
    smallTitle: String,
    description: String,
    photo: String,
    sound: String,
    movie: String
  },
  data: () => ({
    audio: '',
  }),
  mounted() {
    console.log('sound : ', this.sound)

    if (this.sound !== null && this.sound !== '') {
      this.audio = new Audio(utils.File.getDownUrl(this.sound))
      this.audioPlay()
    }
  },
  methods: {
    next() {
      this.audioPause()
      this.$emit('next')
    },
    audioPlay() {
      this.audio.play()
    },
    audioPause() {
      if (this.audio != '') {
        this.audio.pause()
        this.audio.currentTime = 0
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.audioPause()

    next()
  }
};
</script>

